module.exports = __webpack_public_path__ + "static/img/01@2x.a32b28dd.png";